export default __webpack_public_path__ + "static/media/20_dt42.92f356a4.png";